import React from "react";
import DivisionTabsContainer from "../../containers/DivisionTabsContainer";

const Structure = (props) => (
  <div>
    <div style={{ paddingTop: 15 }}>
      <DivisionTabsContainer
        tournament={props.tournament}
        divisions={props.divisions}
        divisionsObject={props.divisionsObject}
        structurePage={true}
        numDivided={props.numDivided}
        teamsPerDivision={props.teamsPerDivision}
        teamsLoaded={props.teamsLoaded}
        maxTeams={props.maxTeams}
        user={props.user}
        userStatus={props.userStatus}
        tournamentStatus={props.tournamentStatus}
        toggleFinishedDialog={props.toggleFinishedDialog}
        userData={props.userData}
      />
    </div>
  </div>
);

export default Structure;
